export default __webpack_public_path__ + "static/media/kitchen4-afterF-768w.340b1157.png";